import isObject from 'lodash/isObject';
import isArray from 'lodash/isArray';
import SelectSvg from '../../img/select.svg';

export const pascalCase = (str) =>
    str
        .replace(/[^a-z0-9]+/gi, ' ')
        .replace(/(\w)(\w*)/g, (g0, g1, g2) => `${g1.toUpperCase()}${g2.toLowerCase()}`)
        .replace(/\s+/gi, '');

export const isMessage = (message) => isObject(message) && typeof message.id !== 'undefined';

export const getComponentFromName = (name, components, defaultComponent = null) => {
    const componentName = pascalCase(name);
    return components[componentName] || components[name] || defaultComponent;
};

export const addNonBreakingSpaces = (str) => (str ? str.replace(/&nbsp;/g, '\u00a0') : '');

export const cleanExternalLinks = (str) =>
    str ? str.replace(/(<a\\b[^<>]*href=['"]?http[^<>]+)>/gi, '$1 target="_blank">') : '';

export const replaceCharacters = (str) => {
    return str || '';
};

export const isActiveUrl = (url, item) => {
    return item && url === item.url;
};

export const hasActiveUrl = (url, items) => {
    return isArray(items)
        ? items.map((it) => ({
              ...it,
              active: isActiveUrl(url, it),
          }))
        : [];
};

export const removeHex = (str) => (str ? str.replace('#', '') : '');

export const getLightBackground = (color = 'FFFFFF') => {
    return color ? `url('/img/tiles/tile-white-vide-filters(background(${color})).png')` : null;
};

export const getDarkBackground = (color = 'FFFFFF') => {
    return color ? `url('/img/tiles/tile-black-vide-filters(background(${color})).png')` : null;
};

export const getDarkBorder = (color = 'FFFFFF') => {
    return color ? `url('/img/tiles/border-black-filters(background(${color})).png')` : null;
};

export const getDarkBorderVertical = (color = 'FFFFFF') => {
    return color
        ? `url('/img/tiles/border-black-vertical-filters(background(${color})).png')`
        : null;
};

export const getQueryValue = (location, variable) => {
    const query = location.search.substring(1);
    const vars = query.split('&');
    for (let i = 0; i < vars.length; i += 1) {
        const pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) === variable) {
            return decodeURIComponent(pair[1]);
        }
    }
    return null;
};

export const selectStyle = {
    container: (provided) => ({
        ...provided,
        border: 0,
        outline: 0,
    }),
    control: (provided) => ({
        ...provided,
        borderWidth: 0,
        color: '#000',
        padding: 2,
        fontWeight: 'bold',
        backgroundColor: 'transparent',
        backgroundImage: `url(${SelectSvg})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        outline: 0,
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#000',
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: '#000',
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        color: '#000',
    }),
    indicatorSeparator: (provided) => ({
        ...provided,
        backgroundColor: 'transparent',
    }),
    menu: (provided) => ({
        ...provided,
        color: '#000',
        backgroundColor: 'transparent',
        margin: 0,
        padding: 0,
        border: 0,
    }),
    menuList: (provided) => ({
        ...provided,
        color: '#000',
        backgroundColor: 'transparent',
        margin: 0,
        padding: 0,
        border: 0,
    }),
    option: (provided) => ({
        ...provided,
        color: '#000',
        fontWeight: 'bold',
        padding: 5,
        backgroundColor: 'transparent',
        backgroundImage: `url(${SelectSvg})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100%',
        margin: '5px 0',
        border: 0,
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
    }),
    a11yText: (provided) => ({
        ...provided,
        margin: 0,
        padding: 0,
        border: 0,
    }),
    singleValue: (provided) => ({
        ...provided,
        lineHeight: 1.2,
        whiteSpace: 'nowrap',
        fontWeight: 'bold',
    }),
    input: (provided) => ({
        ...provided,
        fontWeight: 'bold',
    }),
};
